import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#009d9f] py-16 md:py-24" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {t('cta.title')}
        </h2>
        <p className="text-xl md:text-2xl text-teal-100 mb-10 max-w-2xl mx-auto">
          {t('cta.description')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="tel:+526645142275">
            <Button 
              className="w-full sm:w-auto bg-white text-[#009d9f] hover:bg-slate-100 rounded-full px-10 py-7 text-xl font-semibold shadow-lg hover:shadow-xl transition-all"
              data-testid="cta-call-button"
            >
              <Phone className="w-6 h-6 mr-3" />
              {t('cta.callNow')}
            </Button>
          </a>
          <a 
            href="https://wa.me/526645142275" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button 
              className="w-full sm:w-auto bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full px-10 py-7 text-xl font-semibold shadow-lg hover:shadow-xl transition-all"
              data-testid="cta-whatsapp-button"
            >
              <MessageCircle className="w-6 h-6 mr-3" />
              WhatsApp
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
